import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class DeleteDatasourcesRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteDatasources', { ids: ids });
  }
}
